
import { useState } from 'react';

export default function UserTestimonials() {
  const [showWechatModal, setShowWechatModal] = useState(false);
  const [showAppModal, setShowAppModal] = useState(false);
  const [copyMessage, setCopyMessage] = useState('');

  const wechatId = 'ranqingyuan2024';

  const handleCopyWechat = async () => {
    try {
      await navigator.clipboard.writeText(wechatId);
      setCopyMessage('微信号已复制到剪贴板');
      setTimeout(() => setCopyMessage(''), 3000);
    } catch (err) {
      setCopyMessage('复制失败，请手动复制');
      setTimeout(() => setCopyMessage(''), 3000);
    }
  };

  const testimonials = [
    {
      name: '小美',
      age: 28,
      occupation: '白领',
      content: '用了燃轻元3个月，体重减了12斤！最重要的是完全没有饥饿感，工作效率还提高了。现在朋友们都说我气色特别好～',
      avatar: 'https://public.readdy.ai/ai/img_res/277d21aa9efb83fd08aa039a8c62e0f5.jpg',
      rating: 5,
      tags: ['减重成功', '无饥饿感', '气色变好']
    },
    {
      name: '李先生',
      age: 35,
      occupation: '程序员',
      content: '作为码农经常熬夜加班，之前总是靠咖啡提神。现在有了燃轻元，精神状态稳定多了，而且不会有咖啡因的副作用。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20with%20glasses%20and%20confident%20smile%2C%20business%20casual%20attire%2C%20modern%20office%20background%2C%20energetic%20and%20focused%20expression%2C%20natural%20lighting%2C%20health%20and%20productivity%20concept&width=300&height=300&seq=user2&orientation=squarish',
      rating: 5,
      tags: ['提升精神', '告别咖啡', '工作效率']
    },
    {
      name: '张女士',
      age: 42,
      occupation: '妈妈',
      content: '带娃很累，之前总是想吃甜食缓解压力。燃轻元帮我控制了食欲，现在能更好地照顾家庭，自己的身材也恢复了不少。',
      avatar: 'https://readdy.ai/api/search-image?query=Warm%20and%20caring%20Asian%20mother%20with%20gentle%20smile%2C%20comfortable%20home%20setting%2C%20maternal%20and%20nurturing%20expression%2C%20natural%20lighting%2C%20family%20wellness%20concept%2C%20soft%20and%20approachable%20style&width=300&height=300&seq=user3&orientation=squarish',
      rating: 5,
      tags: ['控制食欲', '身材恢复', '更有活力']
    }
  ];

  const communityFeatures = [
    {
      icon: 'ri-group-line',
      title: '专业指导',
      description: '营养师定期分享健康知识'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: '每日打卡',
      description: '记录体重变化和身体感受'
    },
    {
      icon: 'ri-gift-line',
      title: '专属福利',
      description: '会员专享产品优惠和活动'
    },
    {
      icon: 'ri-chat-smile-line',
      title: '互相鼓励',
      description: '与志同道合的伙伴一起进步'
    }
  ];

  return (
    <>
      <section id="community" className="py-16 lg:py-24 bg-gradient-to-b from-[#f8f9fc] to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-32">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
              用户真实反馈
            </h2>
            <p className="text-sm lg:text-lg text-gray-600 font-light max-w-3xl mx-auto">
              听听轻松伙伴们的真实声音，<br />
              他们的改变，也将是你的可能
            </p>
          </div>

          {/* 用户见证卡片 */}
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-16 lg:mb-20">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-3xl p-6 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                <div className="flex items-center mb-4 lg:mb-6">
                  <img 
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 lg:w-16 h-12 lg:h-16 rounded-full object-cover mr-3 lg:mr-4"
                  />
                  <div>
                    <h4 className="text-sm lg:text-base font-medium text-gray-800">
                      {testimonial.name}
                    </h4>
                    <p className="text-xs lg:text-sm text-gray-500 font-light">
                      {testimonial.age}岁 · {testimonial.occupation}
                    </p>
                  </div>
                </div>

                <div className="flex mb-3 lg:mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm lg:text-base"></i>
                  ))}
                </div>

                <p className="text-xs lg:text-base text-gray-700 font-light leading-relaxed mb-4 lg:mb-6">
                  {testimonial.content}
                </p>

                <div className="flex flex-wrap gap-2">
                  {testimonial.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="px-2 lg:px-3 py-1 bg-[#847eba]/10 text-[#847eba] text-xs lg:text-sm rounded-full font-light">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* 社群介绍 */}
          <div className="bg-gradient-to-br from-[#847eba]/5 to-[#a3c1c3]/5 rounded-3xl p-8 lg:p-12">
            <div className="text-center mb-8 lg:mb-12">
              <h3 className="text-lg lg:text-2xl font-light text-gray-800 mb-4 lg:mb-6">
                加入燃轻元轻松社群
              </h3>
              <p className="text-xs lg:text-base text-gray-600 font-light max-w-2xl mx-auto">
                1000+轻松伙伴的温暖大家庭，<br />
                在这里，每一个小进步都值得被看见和鼓励
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 mb-8 lg:mb-12">
              {communityFeatures.map((feature, index) => (
                <div key={index} className="text-center">
                  <div className="w-12 lg:w-16 h-12 lg:h-16 bg-gradient-to-br from-[#847eba] to-[#a3c1c3] rounded-2xl flex items-center justify-center mx-auto mb-3 lg:mb-4">
                    <i className={`${feature.icon} text-lg lg:text-xl text-white`}></i>
                  </div>
                  <h4 className="text-xs lg:text-sm font-medium text-gray-800 mb-1 lg:mb-2">
                    {feature.title}
                  </h4>
                  <p className="text-xs lg:text-sm text-gray-600 font-light">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>

            <div className="text-center">
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={() => setShowWechatModal(true)}
                  className="inline-flex items-center px-6 lg:px-8 py-3 lg:py-4 bg-[#847eba] text-white rounded-full hover:bg-[#6b5d9a] transition-colors duration-300 text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-wechat-fill mr-2"></i>
                  加入微信社群
                </button>
                
                <button 
                  onClick={() => setShowAppModal(true)}
                  className="inline-flex items-center px-6 lg:px-8 py-3 lg:py-4 border-2 border-[#847eba] text-[#847eba] hover:bg-[#847eba] hover:text-white transition-all duration-300 rounded-full text-sm lg:text-base font-medium whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line mr-2"></i>
                  体验小程序
                </button>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 微信社群弹窗 */}
      {showWechatModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* 毛玻璃背景 */}
          <div 
            className="absolute inset-0 bg-black/30 backdrop-blur-sm"
            onClick={() => setShowWechatModal(false)}
          ></div>
          
          {/* 弹窗内容 */}
          <div className="relative bg-gradient-to-br from-[#847eba]/95 to-[#6b5d9a]/95 backdrop-blur-md rounded-3xl p-8 lg:p-10 max-w-md w-full mx-4 shadow-2xl transform transition-all duration-300">
            {/* 关闭按钮 */}
            <button 
              onClick={() => setShowWechatModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-all duration-200 cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>

            {/* 标题 */}
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-wechat-fill text-2xl text-white"></i>
              </div>
              <h3 className="text-lg lg:text-xl font-medium text-white mb-2">加入微信社群</h3>
              <p className="text-white/80 text-xs lg:text-sm">扫码或添加微信号加入我们的轻松大家庭</p>
            </div>

            {/* 二维码 */}
            <div className="text-center mb-6">
              <div className="bg-white rounded-2xl p-4 inline-block mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=WeChat%20group%20QR%20code%20for%20health%20and%20wellness%20community%2C%20clean%20white%20background%2C%20minimalist%20design%2C%20professional%20group%20invitation%20QR%20code%20style%2C%20clear%20and%20scannable%2C%20modern%20social%20media%20design%20with%20community%20elements&width=200&height=200&seq=wechat-group-qr&orientation=squarish"
                  alt="微信群二维码"
                  className="w-32 h-32 object-contain"
                />
              </div>
              <p className="text-white/90 text-xs lg:text-sm">扫描二维码加入微信群</p>
            </div>

            {/* 微信号 */}
            <div className="bg-white/20 rounded-2xl p-4 mb-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <i className="ri-user-line text-white mr-3"></i>
                  <div>
                    <p className="text-white/80 text-xs">微信号</p>
                    <p className="text-white font-medium text-xs lg:text-base">{wechatId}</p>
                  </div>
                </div>
                <button 
                  onClick={handleCopyWechat}
                  className="px-3 py-1 bg-white/30 hover:bg-white/40 text-white text-xs lg:text-sm rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-file-copy-line mr-1"></i>
                  复制
                </button>
              </div>
            </div>

            {/* 复制提示 */}
            {copyMessage && (
              <div className="text-center mb-4">
                <p className="text-white/90 text-xs lg:text-sm bg-white/20 rounded-full px-4 py-2 inline-block">
                  <i className="ri-check-line mr-1"></i>
                  {copyMessage}
                </p>
              </div>
            )}

            {/* 温馨提示 */}
            <div className="text-center">
              <p className="text-white/70 text-xs leading-relaxed">
                添加微信后请备注"轻松社群"<br />
                我们会尽快邀请您加入群聊
              </p>
            </div>
          </div>
        </div>
      )}

      {/* APP下载弹窗 */}
      {showAppModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* 毛玻璃背景 */}
          <div 
            className="absolute inset-0 bg-black/30 backdrop-blur-sm"
            onClick={() => setShowAppModal(false)}
          ></div>
          
          {/* 弹窗内容 */}
          <div className="relative bg-gradient-to-br from-[#847eba]/95 to-[#6b5d9a]/95 backdrop-blur-md rounded-3xl p-8 lg:p-10 max-w-md w-full mx-4 shadow-2xl transform transition-all duration-300">
            {/* 关闭按钮 */}
            <button 
              onClick={() => setShowAppModal(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-all duration-200 cursor-pointer"
            >
              <i className="ri-close-line text-lg"></i>
            </button>

            {/* 标题 */}
            <div className="text-center mb-6">
              <div className="w-20 h-20 bg-gradient-to-b from-gray-100 to-gray-300 rounded-[22%] flex items-center justify-center mx-auto mb-4 shadow-2xl border border-gray-200/50 relative overflow-hidden">
                {/* iPhone 4风格的光泽效果 */}
                <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/10 to-transparent rounded-[22%]"></div>
                <div className="absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-white/30 to-transparent rounded-t-[22%]"></div>
                
                {/* 主要内容区域 */}
                <div className="absolute inset-2 flex flex-col items-center justify-center z-10">
                  {/* 哈乐猴IP形象 */}
                  <div className="w-8 h-8 mb-1">
                    <img 
                      src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/56bd2c424ca5fcbf472311441b3e29fd.png"
                      alt="哈乐猴"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  {/* 燃轻元文字 */}
                  <div className="text-gray-700 font-medium text-[8px] leading-tight text-center">
                    燃轻元
                  </div>
                </div>
                
                {/* 细微内阴影 */}
                <div className="absolute inset-0 rounded-[22%] shadow-inner"></div>
              </div>
              <h3 className="text-lg lg:text-xl font-medium text-white mb-2">下载燃轻元APP</h3>
              <p className="text-white/80 text-xs lg:text-sm">开启你的轻松健康之旅</p>
            </div>

            {/* 二维码 */}
            <div className="text-center mb-6">
              <div className="bg-white rounded-2xl p-4 inline-block mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Mobile%20app%20download%20QR%20code%20for%20health%20and%20wellness%20app%2C%20clean%20white%20background%2C%20minimalist%20design%2C%20professional%20app%20store%20QR%20code%20style%2C%20clear%20and%20scannable%2C%20modern%20mobile%20technology%20design&width=200&height=200&seq=app-download-qr&orientation=squarish"
                  alt="APP下载二维码"
                  className="w-32 h-32 object-contain"
                />
              </div>
              <p className="text-white/90 text-xs lg:text-sm">扫描二维码下载APP</p>
            </div>

            {/* 下载按钮 */}
            <div className="space-y-3">
              <button className="w-full bg-white/20 hover:bg-white/30 rounded-2xl p-4 transition-all duration-200 cursor-pointer">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center mr-4">
                    <i className="ri-apple-fill text-black text-lg"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-white/90 text-xs">Download on the</p>
                    <p className="text-white font-medium text-sm lg:text-base">App Store</p>
                  </div>
                </div>
              </button>

              <button className="w-full bg-white/20 hover:bg-white/30 rounded-2xl p-4 transition-all duration-200 cursor-pointer">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center mr-4">
                    <i className="ri-google-play-fill text-black text-lg"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-white/90 text-xs">GET IT ON</p>
                    <p className="text-white font-medium text-sm lg:text-base">Google Play</p>
                  </div>
                </div>
              </button>
            </div>

            {/* 温馨提示 */}
            <div className="text-center mt-6">
              <p className="text-white/70 text-xs leading-relaxed">
                即将上线，敬请期待<br />
                加入微信群获取最新发布信息
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
